import{defineMessages}from'react-intl';

export default defineMessages({
events:{
id:'i18n.NavBar.events',
defaultMessage:'Events'},

viewAllEvents:{
id:'i18n.NavBar.viewAllEvents',
defaultMessage:'View All Events'},

pendingApprovals:{
id:'i18n.NavBar.pendingApprovals',
defaultMessage:'Pending Approvals'},

approvedEvents:{
id:'i18n.NavBar.approvedEvents',
defaultMessage:'Approved Events'},

createEvents:{
id:'i18n.NavBar.createEvents',
defaultMessage:'Create Events'},

stockLift:{
id:'i18n.NavBar.stockLift',
defaultMessage:'Event Stock Lift'},

documents:{
id:'i18n.NavBar.documents',
defaultMessage:'Documents'},

settings:{
id:'i18n.NavBar.settings',
defaultMessage:'Settings'},

adminSettings:{
id:'i18n.NavBar.adminSettings',
defaultMessage:'Admin Settings'},

securityRoles:{
id:'i18n.NavBar.securityRoles',
defaultMessage:'Security and Roles'},

eventContacts:{
id:'i18n.NavBar.eventContacts',
defaultMessage:'Event Contacts'},

eventManagers:{
id:'i18n.NavBar.eventManagers',
defaultMessage:'Event Managers'},

brandCommunication:{
id:'i18n.NavBar.brandCommunication',
defaultMessage:'Brand Communication'},

userGreeting:{
id:'i18n.NavBar.userGreeting',
defaultMessage:'Hi'},

changePassword:{
id:'i18n.NavBar.changePassword',
defaultMessage:'Change Password'},

helpFAQ:{
id:'i18n.NavBar.helpFAQ',
defaultMessage:'Help and FAQs'},

signOut:{
id:'i18n.NavBar.signOut',
defaultMessage:'Sign Out'},

createSellingSupport:{
id:'i18n.NavBar.createSellingSupport',
defaultMessage:'CREATE SELLING SUPPORT'}});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/NavBar/NavBar.messages.js
// module id = 728
// module chunks = 0